export default __webpack_public_path__ + "static/media/Grupo-Bancolombia.d5bb79aa.png";